import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BECSEAIMLCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. CSE (AI & Machine Learning)",
    shortName: "B.E. CSE (AI&ML)",
    duration: "4 years",
    description: "Advanced computer science program specializing in artificial intelligence, machine learning, and intelligent systems",
    overview: "Bachelor of Engineering in Computer Science and Engineering with specialization in Artificial Intelligence and Machine Learning (B.E. CSE AI&ML) is a 4-year undergraduate program that combines core computer science with cutting-edge AI and ML technologies. This course prepares students to develop intelligent systems, autonomous applications, and next-generation AI solutions.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong mathematical and analytical skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics", 
          "Chemistry",
          "Programming in Python",
          "Linear Algebra",
          "Statistics and Probability"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures and Algorithms",
          "Discrete Mathematics",
          "Database Management Systems",
          "Object-Oriented Programming",
          "Mathematical Foundations of AI",
          "Introduction to Machine Learning"
        ]
      },
      {
        year: 3,
        subjects: [
          "Machine Learning Algorithms",
          "Deep Learning",
          "Natural Language Processing",
          "Computer Vision",
          "Neural Networks",
          "Pattern Recognition"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced AI Techniques",
          "Reinforcement Learning",
          "AI Ethics and Safety",
          "Robotics and Automation",
          "AI Project Development",
          "Industry Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "AI Engineer",
        "Machine Learning Engineer",
        "Data Scientist",
        "Research Scientist",
        "AI Product Manager",
        "Computer Vision Engineer", 
        "NLP Engineer",
        "Robotics Engineer"
      ],
      industries: [
        "Technology Giants (Google, Apple, Microsoft)",
        "AI Startups",
        "Automotive (Autonomous Vehicles)",
        "Healthcare and Pharmaceuticals",
        "Financial Services",
        "Gaming and Entertainment",
        "Research Institutions",
        "Defense and Aerospace"
      ],
      averageSalary: "₹8-15 LPA (Fresher), ₹25-50 LPA (Experienced)",
      topRecruiters: [
        "Google, Microsoft, Amazon",
        "OpenAI, DeepMind, Anthropic",
        "Tesla, Waymo, Uber",
        "NVIDIA, Intel, Qualcomm",
        "Netflix, Meta, Apple",
        "Research Labs (IISc, IIIT)"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Indian Institute of Technology Madras",
        location: "Chennai",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "Vellore Institute of Technology",
        location: "Chennai",
        fees: "₹1,98,000", 
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "SSN College of Engineering",
        location: "Chennai",
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹2,50,000",
        ranking: "NAAC A++ Grade"
      }
    ],

    skills: [
      "Python/R Programming",
      "Machine Learning Frameworks",
      "Deep Learning (TensorFlow, PyTorch)",
      "Statistical Analysis",
      "Computer Vision",
      "Natural Language Processing",
      "Big Data Technologies",
      "Mathematical Modeling",
      "Research and Innovation",
      "Problem-Solving"
    ],

    futureScope: "Exceptional opportunities in the rapidly expanding AI industry, with applications in autonomous systems, healthcare AI, and emerging technologies like AGI and quantum computing.",

    faqs: [
      {
        question: "What's the difference between AI&ML and Data Science?",
        answer: "AI&ML focuses on creating intelligent systems and algorithms, while Data Science emphasizes extracting insights from data. AI&ML is more algorithm and model development oriented."
      },
      {
        question: "Do I need strong math skills?",
        answer: "Yes, AI&ML requires strong foundations in linear algebra, calculus, statistics, and probability for understanding algorithms and model development."
      },
      {
        question: "What programming languages are essential?",
        answer: "Python is primary, along with R for statistics. Knowledge of C++, Java, and frameworks like TensorFlow and PyTorch is valuable."
      },
      {
        question: "Are there research opportunities?",
        answer: "Extensive research opportunities in universities, tech companies, and specialized AI research labs with possibilities for PhD and academic careers."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BECSEAIMLCoursePage;
